'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* AudioPlayer */

var audioPlayFile = exports.audioPlayFile = function audioPlayFile(file) {
  return {
    type: 'AUDIO_PLAY_FILE',
    file: file
  };
};
var audioPause = exports.audioPause = function audioPause() {
  return {
    type: 'AUDIO_PAUSE'
  };
};

/* currentTask */

var setContent = exports.setContent = function setContent(content) {
  return {
    type: 'SET_CONTENT',
    file: content
  };
};
var setStyle = exports.setStyle = function setStyle(style) {
  return {
    type: 'SET_STYLE',
    file: style
  };
};
var setAlpha = exports.setAlpha = function setAlpha(alpha) {
  return {
    type: 'SET_ALPHA',
    alpha: alpha
  };
};
var createTask = exports.createTask = function createTask(cb) {
  return {
    type: 'CREATE_TASK',
    cb: cb
  };
};
var addTask = exports.addTask = function addTask(task) {
  return {
    type: 'ADD_TASK',
    task: task
  };
};
var updateTask = exports.updateTask = function updateTask(task) {
  return {
    type: 'UPDATE_TASK',
    task: task
  };
};

/* tasks */

var loadTasks = exports.loadTasks = function loadTasks(tasks) {
  return {
    type: 'LOAD_TASKS',
    tasks: tasks
  };
};
var cancelTask = exports.cancelTask = function cancelTask(task) {
  return {
    type: 'CANCEL_TASK',
    task: task
  };
};

/* folders */

var loadFolders = exports.loadFolders = function loadFolders(folders) {
  return {
    type: 'LOAD_FOLDERS',
    folders: folders
  };
};
var loadFiles = exports.loadFiles = function loadFiles(files) {
  return {
    type: 'LOAD_FILES',
    files: files
  };
};
var loadOpenFolders = exports.loadOpenFolders = function loadOpenFolders(folders) {
  return {
    type: 'LOAD_OPEN_FOLDERS',
    folders: folders
  };
};

var initNewFolder = exports.initNewFolder = function initNewFolder() {
  return {
    type: 'INIT_NEW_FOLDER'
  };
};
var cancelNewFolder = exports.cancelNewFolder = function cancelNewFolder() {
  return {
    type: 'CANCEL_NEW_FOLDER'
  };
};
var createNewFolder = exports.createNewFolder = function createNewFolder(name, cb) {
  return {
    type: 'CREATE_NEW_FOLDER',
    name: name,
    cb: cb
  };
};

var openFolder = exports.openFolder = function openFolder(folder, cb) {
  return {
    type: 'OPEN_FOLDER',
    folder: folder,
    cb: cb
  };
};
var closeFolder = exports.closeFolder = function closeFolder(folder) {
  return {
    type: 'CLOSE_FOLDER',
    folder: folder
  };
};

var addFolder = exports.addFolder = function addFolder(folder) {
  return {
    type: 'ADD_FOLDER',
    folder: folder
  };
};
var addFile = exports.addFile = function addFile(file) {
  return {
    type: 'ADD_FILE',
    file: file
  };
};
var addFiles = exports.addFiles = function addFiles(files) {
  return {
    type: 'ADD_FILES',
    files: files
  };
};
var updateFile = exports.updateFile = function updateFile(file) {
  return {
    type: 'UPDATE_FILE',
    file: file
  };
};


//////////////////
// WEBPACK FOOTER
// ./client/actions/index.js
// module id = 6
// module chunks = 0